var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContinuousGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620",
    transform: "translate(-1228 -1752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(1228 1752)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1236.75 1758.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M12.5,36.74H9.165A2.919,2.919,0,0,1,6.25,33.825V22.165A2.919,2.919,0,0,1,9.165,19.25H12.5a2.919,2.919,0,0,1,2.915,2.915v11.66A2.919,2.919,0,0,1,12.5,36.74ZM9.165,21.749a.417.417,0,0,0-.416.416v11.66a.417.417,0,0,0,.416.416H12.5a.417.417,0,0,0,.416-.416V22.165a.417.417,0,0,0-.416-.416Z",
    transform: "translate(2.662 11.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M23.89,40.514H16.8A9.631,9.631,0,0,1,12.514,39.5l-1.573-.786A1.25,1.25,0,0,1,10.25,37.6V25.939a1.249,1.249,0,0,1,.3-.813L19.4,14.806A3.509,3.509,0,0,1,25.39,18.2L23.227,24.69h2.329A4.581,4.581,0,0,1,30,30.381l-1.666,6.664a4.574,4.574,0,0,1-4.444,3.47ZM12.749,36.827l.882.441a7.115,7.115,0,0,0,3.165.747H23.89a2.08,2.08,0,0,0,2.02-1.578l1.666-6.663a2.082,2.082,0,0,0-2.02-2.586H21.493a1.249,1.249,0,0,1-1.185-1.645l2.712-8.135a1.011,1.011,0,0,0-1.727-.977L12.749,26.4Z",
    transform: "translate(5.325 7.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507",
    transform: "translate(2.251 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M14.9,19.737a2.366,2.366,0,0,1-2.294-2.94l1-3.992L11.532,10.82A2.365,2.365,0,0,1,13.2,6.783h2.818l1.239-3.1a2.365,2.365,0,0,1,4.348,0l1.362,3.179,2.7-.081a2.365,2.365,0,0,1,1.672,4.037l-2.111,2.112L26.26,16.8a2.365,2.365,0,0,1-3.468,2.627l-3.423-1.956-3.291,1.957A2.361,2.361,0,0,1,14.9,19.737Zm4.531-4.749a2.36,2.36,0,0,1,1.174.311l3.152,1.8-.922-3.688a2.379,2.379,0,0,1,.622-2.246l1.884-1.884h-2.5a2.363,2.363,0,0,1-2.173-1.433l-1.24-2.894L18.2,7.847a2.365,2.365,0,0,1-2.174,1.434h-2.5l1.884,1.884a2.379,2.379,0,0,1,.623,2.244L15.11,17.1l3.152-1.8a2.362,2.362,0,0,1,1.173-.31Z",
    transform: "translate(3.466 -2.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M12.923,22.07a2.132,2.132,0,0,1-1.059-.282L9.329,20.339,6.793,21.787a2.134,2.134,0,0,1-3.13-2.37l.742-2.968L2.876,14.92a2.134,2.134,0,0,1,1.509-3.644h2l.987-2.3a2.135,2.135,0,0,1,3.923,0l.987,2.3h2a2.134,2.134,0,0,1,1.509,3.644l-1.529,1.53.742,2.968a2.135,2.135,0,0,1-2.071,2.652ZM9.329,17.786a2.14,2.14,0,0,1,1.061.281L12.363,19.2l-.585-2.34a2.142,2.142,0,0,1,.561-2.027l1.053-1.054H12.036a2.13,2.13,0,0,1-1.962-1.295l-.746-1.741L8.583,12.48a2.131,2.131,0,0,1-1.962,1.294H5.264l1.053,1.054a2.143,2.143,0,0,1,.561,2.028L6.294,19.2,8.27,18.066a2.128,2.128,0,0,1,1.059-.281Zm.335-7.828v0Z",
    transform: "translate(-2.251 1.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M24.759,21.907a2.118,2.118,0,0,1-2.053-2.632l.723-2.895L21.94,14.889a2.117,2.117,0,0,1,1.5-3.614h1.941l.961-2.242a2.116,2.116,0,0,1,3.891,0l.961,2.241h1.941a2.117,2.117,0,0,1,1.5,3.614L33.137,16.38l.723,2.9a2.116,2.116,0,0,1-3.1,2.351l-2.473-1.413-2.473,1.414a2.115,2.115,0,0,1-1.051.28Zm3.524-4.25a2.121,2.121,0,0,1,1.052.279l1.884,1.078-.559-2.238a2.129,2.129,0,0,1,.557-2.01l.991-.992H30.938a2.114,2.114,0,0,1-1.946-1.284l-.708-1.653-.708,1.653a2.114,2.114,0,0,1-1.946,1.283H24.357l.991.992a2.129,2.129,0,0,1,.558,2.008l-.56,2.24,1.886-1.078a2.111,2.111,0,0,1,1.05-.278Z",
    transform: "translate(10.443 1.411)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuousGrowth);
export default __webpack_public_path__ + "static/media/continuous-growth.e48db06481829a6ab35234efb024f85f.svg";
export { ForwardRef as ReactComponent };